import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const Icon = ({
  name,
  color
}) => {
  const cls = classNames('icon', {
    [`icon-${name}`]: name,
    'text-primary': color === 'error',
    'text-success': color === 'success',
    'text-theme': color === 'theme'
  });
  return /*#__PURE__*/React.createElement("i", {
    className: cls
  });
};
Icon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.oneOf(['red', 'error', 'success'])
};
export default Icon;